(function () {
  function updateCheckoutText() {
    const checkoutBtn = document.getElementById("CartDrawer-Checkout");
    if (!checkoutBtn) return;

    const text = checkoutBtn.textContent || "";

    if (text.includes("WITH PROTECTION")) return;

    const match = text.match(/\|\s*(.*)/);
    const price = match ? match[1] : "";

    checkoutBtn.textContent = `CHECKOUT WITH PROTECTION | ${price}`;
  }

  function applyStyles() {
    const widgetContainer = document.getElementById("_si-widget-container-804");
    const checkoutBtn = document.getElementById("CartDrawer-Checkout");

    if (!widgetContainer || !checkoutBtn) return;

    const widgetButton = widgetContainer.querySelector("#_si-sec-checkout-id");
    if (!widgetButton) return;

    if (widgetButton.dataset.styled === "true") return;

    const checkoutStyles = window.getComputedStyle(checkoutBtn);

    widgetButton.style.padding = checkoutStyles.padding;
    widgetButton.style.fontSize = checkoutStyles.fontSize;
    widgetButton.style.fontWeight = checkoutStyles.fontWeight;
    widgetButton.style.fontFamily = checkoutStyles.fontFamily;

    widgetButton.style.backgroundColor = "#606d22";
    widgetButton.style.borderColor = "#606d22";
    widgetButton.style.borderRadius = "100px";
    widgetButton.style.textTransform = "uppercase";
    widgetButton.style.color = "#fff";

    const subtotal = document.querySelector(
      ".totals.cart-subtotal-price .totals__subtotal-value",
    );

    if (subtotal) {
      widgetButton.innerText =
        "Checkout without protection | " + subtotal.innerText;
    }

    checkoutBtn.style.backgroundColor = "transparent";
    checkoutBtn.style.textTransform = "capitalize";
    checkoutBtn.style.border = "1px solid #606d22";
    checkoutBtn.style.color = "#606d22";

    widgetButton.dataset.styled = "true";
  }

  const observer = new MutationObserver(() => {
    applyStyles();
    updateCheckoutText();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });

  applyStyles();
  updateCheckoutText();
})();


(function () {
  function updateCheckoutText() {
    const checkoutBtn = document.getElementById("checkout");
    if (!checkoutBtn) return;

    const text = checkoutBtn.textContent || "";

    if (text.includes("WITH PROTECTION")) return;

    const match = text.match(/\|\s*(.*)/);
    const price = match ? match[1] : "";

    checkoutBtn.textContent = `CHECKOUT WITH PROTECTION | ${price}`;
  }

  function applyStyles() {
    const widgetContainer = document.getElementById("_si-widget-container-806");
    const checkoutBtn = document.getElementById("checkout");

    if (!widgetContainer || !checkoutBtn) return;

    const widgetButton = widgetContainer.querySelector("#_si-sec-checkout-id");
    if (!widgetButton) return;

    if (widgetButton.dataset.styled === "true") return;

    const checkoutStyles = window.getComputedStyle(checkoutBtn);

    widgetButton.style.padding = checkoutStyles.padding;
    widgetButton.style.fontSize = checkoutStyles.fontSize;
    widgetButton.style.fontWeight = checkoutStyles.fontWeight;
    widgetButton.style.fontFamily = checkoutStyles.fontFamily;

    widgetButton.style.backgroundColor = "#606d22";
    widgetButton.style.borderColor = "#606d22";
    widgetButton.style.borderRadius = "100px";
    widgetButton.style.textTransform = "uppercase";
    widgetButton.style.color = "#fff";

    const subtotal = document.querySelector(
      ".totals__subtotal-value .h2"
    );

    if (subtotal) {
      widgetButton.innerText =
        "Checkout without protection | " + subtotal.innerText.trim();
    }

    checkoutBtn.style.backgroundColor = "transparent";
    checkoutBtn.style.textTransform = "capitalize";
    checkoutBtn.style.border = "1px solid #606d22";
    checkoutBtn.style.color = "#606d22";

    widgetButton.dataset.styled = "true";
  }

  const observer = new MutationObserver(() => {
    applyStyles();
    updateCheckoutText();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });

  applyStyles();
  updateCheckoutText();
})();